import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin')
  .config(bringozConfig);

/* @ngInject */
function bringozConfig($logProvider, apiConfig, uiGmapGoogleMapApiProvider,
                       $windowProvider, $mdDateLocaleProvider, splitConstants,
                       HeapProvider, intercomProvider, GTagProvider, sisenceProvider, moment) {
  //$urlRouterProvider.deferIntercept();
  const localStorage = $windowProvider.$get().localStorage;
  const siteLocale = localStorage.getItem('siteLocale');
  const userLocale = localStorage.getItem('NG_TRANSLATE_LANG_KEY');
  const userTimezone = localStorage.getItem('TIME_ZONE_KEY');
  const intercomAppId = apiConfig.intercom.appId;
  const mapsLanguage = (siteLocale || userLocale || 'en').substr(0, 2);
  const intercomLanguage = (userLocale || 'en').substr(0, 2);

  if (!!userTimezone) {
    moment.tz.setDefault(userTimezone);
  }


  if (_.isString(apiConfig.debug)) {
    apiConfig.debug = (apiConfig.debug === 'true');
  }
  // Pass the boolean itself. An array literal is always truthy, so wrapping the
  // flag kept $log.debug enabled in every environment, including production.
  $logProvider.debugEnabled(apiConfig.debug);

  // Init Google Maps
  // uiGmapMapScriptLoader turns every option below into a query param and already injects a
  // `callback`, so `loading: 'async'` is the supported way to clear the Maps loading warning.
  uiGmapGoogleMapApiProvider.configure({
    key: apiConfig.google.mapsKey,
    language: mapsLanguage,
    v: '3.64',
    loading: 'async',
    libraries: 'places,geometry,visualization'
  });

  // Init Intercom
  intercomProvider.initConfigure(intercomAppId, intercomLanguage);

  // Init Sisence
  sisenceProvider.initScript(apiConfig.sisence.url);

  // Init Heap
  // HeapProvider.load(apiConfig.heap.appId);

  // Init Google Tag Manager
  GTagProvider.init(apiConfig.google.tagId);

  // Init Browser Print
  // browserPrintProvider.initScript();

  ///// EVENTS /////

  //md-datepicker event
  $mdDateLocaleProvider.formatDate = function (date) {
    const currentLocale = localStorage.getItem('siteLocale') || 'he_IL',
      localCode = currentLocale.substr(0, 2),
      dateAndTimeFormats = splitConstants.dateAndTimeFormats,
      format = dateAndTimeFormats[localCode] || dateAndTimeFormats['he'];
    // configTimeZone = localStorage.getItem('TIME_ZONE_KEY') || moment.tz.guess(),
    // configTimeZoneOffset = moment.tz.zone(configTimeZone).utcOffset(date),
    // timeStampDate = moment.tz(date, configTimeZone).valueOf();

    return date ? moment(date).format(format.long) : '';

  };

  $mdDateLocaleProvider.parseDate = function (dateString) {
    const currentLocale = localStorage.getItem('siteLocale') || 'he_IL',
      localCode = currentLocale.substr(0, 2),
      dateAndTimeFormats = splitConstants.dateAndTimeFormats,
      format = dateAndTimeFormats[localCode] || dateAndTimeFormats['he'];

    const m = moment(dateString, format.long, true);
    return m.isValid() ? m.toDate() : new Date(NaN);
  };

}
